import { hex2rgb } from '../../services/vuestic-ui'

const generateValue = () => {
  return Math.floor(Math.random() * 100)
}

const generateYLabels = () => {
  return ['Deposits', 'Withdrawals']
}

const generateArray = (length) => {
  return Array.from(Array(length), generateValue)
}

const createString = (arr, key) => {
  return arr.map(function (obj) {
    return obj[key]
  }).join(',')
}

const getSize = () => {
  const minSize = 4
  return Math.max(minSize, new Date().getMonth())
}

let generatedData
let firstMonthIndex = 0

export const getLineChartData = (res, themes, firstMonth) => {
  let monthlabels = []
  let deposits = []
  let expenses = []

  monthlabels = createString(res, 'income_month').split(',')
  deposits = createString(res, 'income_amt').split(',')
  expenses = createString(res, 'expense').split(',')

  const size = getSize()

  const months = monthlabels // ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  const yLabels = generateYLabels()

  if (generatedData) {
    generatedData.datasets[0].backgroundColor = hex2rgb(themes.info, 0.6).css
    generatedData.datasets[1].backgroundColor = hex2rgb(themes.primary, 0.6).css
    if (firstMonth && firstMonthIndex !== firstMonth) {
      generatedData.labels.shift()
      generatedData.datasets.forEach((dataset) => {
        dataset.data.shift()
      })
      firstMonthIndex = firstMonth
    }
  } else {
    generatedData = {
      labels: months.splice(firstMonthIndex, size),
      datasets: [
        {
          label: yLabels[0],
          backgroundColor: hex2rgb(themes.info, 0.6).css,
          borderColor: 'transparent',
          data: deposits,
        },
        {
          label: yLabels[1],
          backgroundColor: hex2rgb(themes.primary, 0.6).css,
          borderColor: 'transparent',
          data: expenses,
        },
      ],
    }
  }

  return generatedData
}
